import { createContext, useContext, useEffect } from "react";
import React from "react";

export interface AppFwContextMenuAction {
    key?: string;
    icon?: React.ReactNode;
    text: string;
    onClick: () => void;
}

export interface AppFwContextMenuContextType {
    setActions: (actions: AppFwContextMenuAction[]) => void;
    actions: AppFwContextMenuAction[];
}

export const AppFwContextMenuContext = createContext<AppFwContextMenuContextType>({
    setActions: () => { },
    actions: [],
});

export const useAppFwContextMenuActions = (actions: AppFwContextMenuAction[]) => {
    const context = useContext(AppFwContextMenuContext);

    useEffect(() => {
        context.setActions(actions);
        return () => context.setActions([]);
    }, [actions, context]);
}
